import styled from "styled-components";

import { entryColors, entryFont } from "@entry/tokens";

export const SliderCard = styled.div`
  box-sizing: border-box;
  padding: 20px 24px;
  border-radius: 16px;
  background: ${entryColors.glassFill};
  border: 1px solid ${entryColors.glassBorder};
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
`;

export const AxisLabel = styled.button`
  display: block;
  width: 100%;
  border: none;
  background: transparent;
  padding: 0;
  font-family: ${entryFont.body};
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.65);
  text-align: left;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${entryColors.highlight};
    outline-offset: 2px;
    border-radius: 4px;
  }
`;

export const Rail = styled.div`
  position: relative;
  margin: 20px 0 20px 8px;
  padding-left: 32px;
  touch-action: none;

  /* Unfilled track, full height. */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: -1px;
    width: 2px;
    background: rgba(255, 255, 255, 0.16);
  }
`;

export const FilledLine = styled.div<{ $height: number }>`
  position: absolute;
  top: 0;
  left: -1px;
  width: 2px;
  height: ${({ $height }) => $height}px;
  background: ${entryColors.terracotta};
  pointer-events: none;
`;

export const Thumb = styled.div<{ $y: number; $dragging: boolean }>`
  position: absolute;
  top: ${({ $y }) => $y}px;
  left: -8px;
  width: 16px;
  height: 16px;
  margin-top: -8px;
  border-radius: 50%;
  background: ${entryColors.terracotta};
  box-shadow: 0 0 16px rgba(205, 128, 84, 0.7);
  pointer-events: none;
  transition: ${({ $dragging }) => ($dragging ? "none" : "top 200ms ease")};
`;

export const StopRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Stop = styled.button<{ $selected: boolean }>`
  display: block;
  width: 100%;
  background: transparent;
  border: none;
  padding: 8px 0;
  cursor: pointer;
  font-family: ${entryFont.body};
  font-size: 16px;
  font-weight: ${({ $selected }) => ($selected ? 700 : 500)};
  color: ${({ $selected }) => ($selected ? entryColors.textPrimary : "rgba(255, 255, 255, 0.55)")};
  transition: color 160ms ease;
  text-align: left;
  touch-action: none;

  @media (hover: hover) {
    &:hover {
      color: ${entryColors.textPrimary};
    }
  }

  &:focus-visible {
    outline: 2px solid ${entryColors.highlight};
    outline-offset: 2px;
    border-radius: 6px;
  }
`;
